import type { Card } from '../../types';

export const JAB: Card = {
  id: 'jab',
  name: 'Jab',
  type: 'attack',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [{ kind: 'min', value: 1 }],
  effects: [{ kind: 'damage', amount: 3 }],
};
